import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getUsersAPI } from './api';

export const GET_USERS = 'getUsers';

export function useGetUsers() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_USERS, tenantId,
  ], () => getUsersAPI());

  return {
    users: data?.items || [],
    isLoading,
    isFetching,
    isError,
  };
}

